import type { IconSvgObject } from './types';

const PanelsRightBottomIcon: IconSvgObject = [
  ["path", { d: "M2.49219 12C2.49219 7.52166 2.49219 5.28249 3.88343 3.89124C5.27467 2.5 7.51384 2.5 11.9922 2.5C16.4705 2.5 18.7097 2.5 20.1009 3.89124C21.4922 5.28249 21.4922 7.52166 21.4922 12C21.4922 16.4783 21.4922 18.7175 20.1009 20.1088C18.7097 21.5 16.4705 21.5 11.9922 21.5C7.51384 21.5 5.27467 21.5 3.88343 20.1088C2.49219 18.7175 2.49219 16.4783 2.49219 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9922 21.5L14.9922 2.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.49219 16L14.9922 16", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default PanelsRightBottomIcon;
